import React from 'react';
import PropTypes from 'prop-types';
import Logger from '../../../../../ui-kitchen/src/utils/logger';

class CustomImage extends React.Component {
  state = {
    imageValue: '',
    imageFile: null,
  }

  componentDidMount() {
    this.fetchImage();
  }

  renderInnerHTML = (outerTag) => {
    if (outerTag) {
      const { imageFile } = this.state;
      outerTag.innerHTML = imageFile; // eslint-disable-line
    }
  }

  fetchImage = async () => {
    const { imageName, baseRequestUrl } = this.props;
    const endPoint = `${baseRequestUrl}GDA/images/${imageName}`;
    let imageValue = '';
    try {
      const dataResponse = await fetch(endPoint);
      const imageFile = await dataResponse.text();
      this.setState({ imageFile });

      const { status } = dataResponse;
      if (status === 200) {
        imageValue = 'present';
      } else {
        imageValue = 'notpresent';
      }
    } catch (err) {
      Logger.error('[CustomImage] Error:', err);
    }

    this.setState({ imageValue });
  }

  render() {
    const { imageValue } = this.state;
    const {
      imageName, baseRequestUrl, fileType, className, width, height, alt,
    } = this.props;
    if (fileType === 'svg' && imageValue === 'present') {
      return (
        <i
          className={className}
          ref={this.renderInnerHTML}
        />
      );
    } if (imageValue === 'notpresent') {
      return (
        <img width={width} height={height} src={`${baseRequestUrl}GDA/images/ImageNotAvailable.svg`} alt="Not Available" />
      );
    }

    return (
      <img src={`${baseRequestUrl}GDA/images/${imageName}`} {...(className ? { className } : {})} alt={alt} />
    );
  }
}

CustomImage.defaultProps = {
  className: '',
  height: '33px',
  width: '33px',
  fileType: '',
  alt: '',
};

CustomImage.propTypes = {
  imageName: PropTypes.string.isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  fileType: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  alt: PropTypes.string,
};

export default CustomImage;
